// extracted by mini-css-extract-plugin
module.exports = {"Lines":"src-components-Main-Infos-Lines-Lines--1F-lo","line":"src-components-Main-Infos-Lines-Lines--3aqn1"};